/**
 * Keeps the magic-link token on an in-app route. Matches `useRouteWithToken`:
 * a route without a query gets `/?linkId=`, one that already has a query gets
 * `&linkId=`. A route that already names `linkId` is left as-is.
 */
export function routeWithLinkId(
  route: string,
  linkId: string | null | undefined,
): string {
  if (!linkId) return route;
  const query = route.includes("?") ? route.slice(route.indexOf("?") + 1) : "";
  if (new URLSearchParams(query).get("linkId")) return route;
  const connector = route.includes("?") ? "&" : "/?";
  return `${route}${connector}linkId=${linkId}`;
}
